import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateDriverHomeLocationMutationVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
  homeLocationId?: Types.InputMaybe<Types.Scalars['bigint']['input']>;
}>;


export type UpdateDriverHomeLocationMutation = { __typename?: 'mutation_root', update_drivers?: { __typename?: 'drivers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'drivers', id: number, home_location_id?: number | null, home_location?: { __typename?: 'locations', id: number, address_line_one?: string | null, address_line_two?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, latitude?: number | null, longitude?: number | null, place_id?: string | null, timezone?: string | null } | null }> } | null };


export const UpdateDriverHomeLocationDocument = gql`
    mutation UpdateDriverHomeLocation($driverId: bigint!, $homeLocationId: bigint) {
  update_drivers(
    where: {id: {_eq: $driverId}}
    _set: {home_location_id: $homeLocationId}
  ) {
    affected_rows
    returning {
      id
      home_location_id
      home_location {
        id
        address_line_one
        address_line_two
        city
        state
        zip_code
        latitude
        longitude
        place_id
        timezone
      }
    }
  }
}
    `;
export type UpdateDriverHomeLocationMutationFn = Apollo.MutationFunction<UpdateDriverHomeLocationMutation, UpdateDriverHomeLocationMutationVariables>;

/**
 * __useUpdateDriverHomeLocationMutation__
 *
 * To run a mutation, you first call `useUpdateDriverHomeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverHomeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverHomeLocationMutation, { data, loading, error }] = useUpdateDriverHomeLocationMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      homeLocationId: // value for 'homeLocationId'
 *   },
 * });
 */
export function useUpdateDriverHomeLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverHomeLocationMutation, UpdateDriverHomeLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverHomeLocationMutation, UpdateDriverHomeLocationMutationVariables>(UpdateDriverHomeLocationDocument, options);
      }
export type UpdateDriverHomeLocationMutationHookResult = ReturnType<typeof useUpdateDriverHomeLocationMutation>;
export type UpdateDriverHomeLocationMutationResult = Apollo.MutationResult<UpdateDriverHomeLocationMutation>;
export type UpdateDriverHomeLocationMutationOptions = Apollo.BaseMutationOptions<UpdateDriverHomeLocationMutation, UpdateDriverHomeLocationMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/drivers/queries/updateDriverHomeLocation.mutation.gql}
 */
export async function updateDriverHomeLocation(
  variables: UpdateDriverHomeLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateDriverHomeLocationMutation['update_drivers']>
export async function updateDriverHomeLocation(
  variables: UpdateDriverHomeLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateDriverHomeLocationMutation>
export async function updateDriverHomeLocation(
  variables: UpdateDriverHomeLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateDriverHomeLocationMutation['update_drivers'] | UpdateDriverHomeLocationMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateDriverHomeLocationMutation>(
    UpdateDriverHomeLocationDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_drivers
}